<template>
  <div class="mc-widget-call-broadcast__item-inothercall-wrapper">
    <div>
      <h4 class="mc-widget-call-broadcast__licenseplate">{{ licensePlate }}</h4>
      <p class="mc-widget-call-broadcast__driver">{{ driver ?? $t('global.text.noDriver') }}</p>
    </div>
    <div class="mc-widget-call-broadcast__state-title-wrapper">
      <p class="mc-widget-call-broadcast__state-title">
        {{ $t('trackVideo.inOtherCall') }}
      </p>
      <i
        :title="$t('trackVideo.end')"
        class="mc-fa icon-fill_close"
        @click="$emit('endBroadcast')"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'StateInOtherCall',
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    driver: {
      validator: (value) => typeof value === 'string' || value === null,
      required: true,
    },
  },
}
</script>
<style lang="scss">
.mc-widget-call-broadcast__item-inothercall-wrapper {
  display: flex;
  align-items: start;
  justify-content: space-between;
  p.mc-widget-call-broadcast__state-title {
    color: $red-500;
  }
  .mc-widget-call-broadcast__state-title-wrapper {
    i.icon-fill_close {
      display: block;
    }
  }
}
</style>
